import { render, staticRenderFns } from "./web.vue?vue&type=template&id=45043fce&scoped=true&"
import script from "./web.vue?vue&type=script&lang=js&"
export * from "./web.vue?vue&type=script&lang=js&"
import style0 from "./web.vue?vue&type=style&index=0&id=45043fce&prod&lang=scss&scoped=true&"
import style1 from "./web.vue?vue&type=style&index=1&id=45043fce&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45043fce",
  null
  
)

export default component.exports